import { HandCoins } from "lucide-react";

/**
 * BrandStamp — a big, prominent "TopRate" wordmark that appears between
 * sections down the page. Variants keep the visual rhythm interesting.
 */
export default function BrandStamp({ variant = "light", tagline }) {
  const isDark = variant === "dark";
  const isGold = variant === "gold";

  const wrap = isDark
    ? "bg-[#2D181A] text-[#FFFDF8] border-y border-[#D4AF37]/25"
    : isGold
    ? "bg-[#D4AF37] text-[#2D181A] border-y border-[#B8860B]"
    : "bg-[#FFFDF8] text-[#641C24] border-y border-[#E5DCC5]";

  const accent = isDark
    ? "text-[#D4AF37]"
    : isGold
    ? "text-[#641C24]"
    : "text-[#D4AF37]";

  const line = isDark
    ? "text-[#FFFDF8]/70"
    : isGold
    ? "text-[#2D181A]/70"
    : "text-[#4A3B3C]";

  return (
    <section
      data-testid={`brand-stamp-${variant}`}
      className={`${wrap} overflow-hidden`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-10">
          <div className="flex items-center gap-4 md:gap-6">
            <span
              className={`inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 shrink-0 border-2 ${
                isDark
                  ? "border-[#D4AF37] text-[#D4AF37]"
                  : isGold
                  ? "border-[#641C24] text-[#641C24]"
                  : "border-[#D4AF37] text-[#641C24]"
              }`}
              aria-hidden="true"
            >
              <HandCoins size={30} strokeWidth={1.6} />
            </span>
            <div className="font-display font-black tracking-tight leading-none text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
              Top<span className={accent}>Rate</span>
            </div>
          </div>
          <div
            className={`text-[10px] md:text-xs uppercase tracking-[0.32em] font-semibold text-center md:text-right ${line} max-w-md`}
          >
            {tagline || (
              <>
                Cash for Gold <span className={accent}>·</span> Sona Do Paisa
                Lo <span className={accent}>·</span> Best Rate for Your
                Jewellery
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
